var app = angular.module('leonardo');

var RestangularRun = function(RestangularProvider, ConfigThemeService) {
  RestangularProvider.setBaseUrl(ConfigThemeService.config.url_config.api_url + '/api/2.0');
};

app.run(['Restangular', 'ConfigThemeService', RestangularRun]);
